import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import FieldText from '@react-form-fields/material-ui/components/Text';
import clsx from 'clsx';
import DateRangeField, { DateRange } from 'components/Shared/DateRanger';
import { statuses, statusFilters } from 'interfaces/file';
import MagnifyIcon from 'mdi-react/MagnifyIcon';
import React, { useCallback } from 'react';
import Button from '@material-ui/core/Button';

interface IProps {
  term?: string;
  handleChangeTerm: (value: any) => void;
  date?: DateRange;
  handleChangeDate: (date: DateRange) => void;
  status?: statuses[]
  handleChangeStatus: (value?: statuses[]) => void;
}

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  statusGroup: {
    gap: theme.spacing(1),
    borderRadius: 0
  },
  statusButton: {
    borderRadius: theme.spacing(1),
    borderColor: '#F3F3F3',
    borderStyle: 'solid',
    borderWidth: 2,
    padding: theme.spacing(0.5),
    '&.active': {
      backgroundColor: theme.palette.secondary.main
    }
  }
}));

const Filters = (props: IProps) => {
  const { term, handleChangeTerm, date, handleChangeDate, status, handleChangeStatus } = props;
  const classes = useStyles();

  const onChangeStatus = useCallback((value: statuses[]) => () => {
    if (status === value) return handleChangeStatus(null);
    handleChangeStatus(value);
  }, [handleChangeStatus, status]);

  return (
    <Grid container className={classes.root} spacing={2}>
      <Grid item xs={12} sm={6} md={4}>
        <FieldText
          label="Pesquisar"
          value={term}
          onChange={handleChangeTerm}
          margin="none"
          placeholder="Digite ao menos 3 caracteres..."
          InputLabelProps={{
            shrink: true
          }}
          helperText="Pesquise pelo nome do documento."
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton disabled={true}>
                  <MagnifyIcon />
                </IconButton>
              </InputAdornment>
            )
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <DateRangeField
          maxDate={new Date()}
          value={date}
          InputAdornmentProps={
            <InputAdornment position="end">
              <IconButton disabled={true}>
                <MagnifyIcon />
              </IconButton>
            </InputAdornment>
          }
          onChange={handleChangeDate}
        />
      </Grid>
      <Grid item>
        <Typography variant="caption" color="textSecondary" component="h1">Filtrar por Status</Typography>
        <Grid container>
          {statusFilters.map(({ icon: Icon, ...i }) => (
            <Grid item key={i.label}>
              <IconButton
                className={clsx(classes.statusButton, { active: status === i.statuses })}
                onClick={onChangeStatus(i.statuses)}
                title={i.label}
              >
                <Icon />
              </IconButton>
            </Grid>
          ))}
          {Boolean(status && status.length) && (
            <Grid item>
              <Button className={classes.statusButton} onClick={onChangeStatus([])}>
                Limpar Filtros
              </Button>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Filters;